import React, { useEffect, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { default as ReactSelect, components } from "react-select";
import useLoginInfo from "hooks/useLoginInfo";
import Maybe from "components/__new/common/Maybe";
import useBanks from "hooks/useBanks";


const SearchableBanks = React.forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { banks, banksLoading } = useBanks(userInfo?.token);


    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState({});


    const getOptions = () => {
        if (banks !== undefined && banks?.length > 0){
          const data = banks?.map((bank) => {
            return {
              label: bank.name,
              value: bank.code,
            }
          })
          setOptions(data);
        }
        else{
            setOptions([]);
        }
    }


    const updateSelection = (e) => {
        setSelectedOption(e);
        props.onValueChange(e);
    }


    const clearSearchableBanks = () => {
        setSelectedOption({});
    }

    useEffect(() => {
        if (banks){
            getOptions();
        }
        // eslint-disable-next-line
    }, [banks]);


    useImperativeHandle(ref, () => ({
        clearSearchableBanks
    }));

    return (
        <div className="form-group">
            <label>
                Select Bank
                <span className="form-input-required">*</span>
            </label>

            <Maybe condition={banksLoading === true}>
                <input type="text" value="Loading banks..." readOnly={true} className="form-input" />
            </Maybe>

            <Maybe condition={banksLoading === false}>
                <ReactSelect
                    options={options}
                    placeholder="Select bank"
                    noOptionsMessage={() => "No banks yet"}
                    isSearchable
                    styles={ReactSelectStyles}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    components={{Option}}
                    onChange={(e) => updateSelection(e)}
                    value={selectedOption}
                />
            </Maybe>
        </div>
    )
})


const Option = (props) => {
    return (
        <div className="p-0">
            <components.Option {...props}>
                <div className="-mx-2 -my-1.5 p-4 text-sm flex justify-between border rounded-sm">
                    <div className="w-10 flex-shrink-0">
                      <input
                        type="radio"
                        checked={props.isSelected}
                        onChange={() => null}
                        className="w-5 h-5 form-radio rounded-full"
                      />
                    </div>
                    <div className="flex-grow text-left font-semibold">
                      {props.label}
                    </div>
                </div>
            </components.Option>
        </div>
    );
};

const ReactSelectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: "#333",
        background: "#fff",
        cursor: "pointer",
        "&:hover": {
            background: "#eee",
        }
      }),
};
  
  

export default SearchableBanks;